import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyInvoices, SupplyInvoice } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplyInvoicesModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplyInvoice> useData={useSupplyInvoices} config={config} />;
};

export default List;
